/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */ import $ from "jquery";
import "./style/welcome.scss";
import { subscribe } from "./others";
import { __ } from "./utils";
$(document).on("click", ".about-wrap .real-utils-newsletter-box .button-hero", async function(e) {
    e.preventDefault();
    const $box = $(this).parents(".real-utils-newsletter-box");
    const slug = $(this).parents(".wrap").data("slug");
    const email = `${$("input[name='newsletter-email']").val()}`;
    const privacy = $box.find("input[type='checkbox']").is(":checked");
    const $errorMsg = $box.find(".error-msg").hide();
    $(this).html(__("Loading...")).addClass("button-primary");
    try {
        await subscribe({
            slug,
            email,
            privacy
        });
        $(this).html(__("Successfully subscribed!")).removeClass("button-primary");
    } catch (e) {
        $(this).html(__("Subscribe"));
        $errorMsg.html(e.responseJSON.message).show();
    }
});
